import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
    ControlBar,
    ReplayControl,
    ForwardControl,
    CurrentTimeDisplay,
    TimeDivider,
    PlaybackRateMenuButton,
    VolumeMenuButton,
} from "video-react";
import YouTube from 'react-youtube'; // Import the YouTube player
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import ChapterList from "../textbook/chapterList";
import { updatePageTitle } from "../../utls/lib";
import UNIT1 from "../../assets/images/classroom/Smart-Biology-CELLS-U1-Cover-Image.jpg";
import UNIT2 from "../../assets/images/classroom/Smart-Biology-CELLS-U2-Cover-Image.jpg";


function IcbSeriesComponent() {
    const [currentPage, setCurrentPage] = useState(0);

    const UnitCard = ({
        index,
        backgroundColor,
        title,
        id,
        description,
        imageURL,
        videoPosterURL,
        videoURL,
        chapterList,
    }) => {
        return (
            <div
                id={id}
                style={{
                    "padding-bottom": "10px",
                }}
            >
                <Container>
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "start",
                        }}
                    >
                        <Col>
                            <div>
                                <br />
                                <h6 style={{ "text-align": "left", "font-weight": "300" }}>
                                    Table of Contents
                                </h6>
                            </div>
                            {chapterList}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };

    // YouTube Player options
	const opts = {
        height: '390', // Reduced from 390
        width: '640',  // Reduced from 640
        playerVars: {
            autoplay: 0, // 0 = no autoplay, 1 = autoplay
        },
    };

    const onReady = (event) => {
        // You can access the player instance here (event.target)
        console.log("YouTube Player Ready");
    };


    return (
        // <div width="100%" style={{backgroundColor: "#f8f9fa", padding: "20px"}}>
        <div width="100%" style={{}}>

            <div style={{ "margin-top": "15px" }}>
                <Row>
                    <Col md={10} sm={10} lg={10} xl={10} xxl={10}>
                        <div>
                            <p>In partnership with MacMillan University</p>
                            <h3 style={{ fontSize: "42px" }}>
                                Interactive Cell Biology
                            </h3>
							<h4>
                            Seeing is Understanding: A Journey through Cell Biology
                        </h4>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <hr />
                    </Col>
                </Row>

                <Row>
                    <Col style={{textAlign: "center"}}>
					<p style={{ "font-size": "19px", "text-align": "justify" }}>
                            Interactive Cell Biology (ICB) provides a consistent, continuous learning journey with powerful 3-D animations, integrated assessment, and a guiding narrative. Students can engage with and explore cellular processes while they navigate through the details, big picture, and evolutionary perspective. Available in Achieve from Macmillan Learning and Smart Biology.
                        </p>
						<a href="https://www.macmillanlearning.com/college/us/preview/icb#" target="_blank">
					<button  className="header-button" >Learn More at MacMillanLearning.com</button>
				</a>
                    </Col>
                    <Col sm={8} md={8} lg={8} xl={8} xxl={8} style={{ textAlign: "center"}}>
                        {/* Replace the video-react Player with the YouTube component */}
                        <YouTube
                            videoId="Ngzs8PEVqWI" // **Replace with your Video ID**
                            opts={opts}
                            onReady={onReady}
                        />
                    </Col>
                </Row>

                <Row
                    style={{
                        padding: "10px",
                        width: "80vw",
                        margin: "2px",
                        borderRadius: "10px",
                    }}
                >
                    <Col style={{ textAlign: "center", color: "black" }}>
                        <div
                            className="grid-container-double"
                            style={{ justifyContent: "center", alignContent: "center" }}
                        >

                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default IcbSeriesComponent;